export default __webpack_public_path__ + "static/media/greenArrowUp.a7f7ba3d.svg";